import { KYMW0F00Component } from './kymw0f00.component';
import { KYMW0F00OutputModel } from './vo/kymw0f00-output.model';
import { GroupingDataModel } from './vo/grouping-data.model';

/**
 * グルーピング選択画面の値を管理するクラス
 *
 * @export KYMW0F00Model
 * @class KYMW0F00Model
 */
export class KYMW0F00Model {

  kymw0F00Component: KYMW0F00Component = null;

  // 生協コンボ
  public coopList142: Array<any> = [];
  public coopList163: Array<any> = [];
  public coopList185: Array<any> = [];
  public coopList240: Array<any> = [];
  public coopList210: Array<any> = [];
  public coopList302: Array<any> = [];
  public coopList515: Array<any> = [];
  public coopList451: Array<any> = [];

  // グルーピングマスタ情報一覧データ
  public groupingInfoList: Array<any> = [];

  // 画面描画用
  public coop142 = String('0');
  public coop163 = String('0');
  public coop185 = String('0');
  public coop240 = String('0');
  public coop210 = String('0');
  public coop302 = String('0');
  public coop515 = String('0');
  public coop451 = String('0');

  /**
   * コンストラクタ
   */
  public constructor() {
    this.coopList142 = this.getCoopList();
    this.coopList163 = this.getCoopList();
    this.coopList185 = this.getCoopList();
    this.coopList240 = this.getCoopList();
    this.coopList210 = this.getCoopList();
    this.coopList302 = this.getCoopList();
    this.coopList515 = this.getCoopList();
    this.coopList451 = this.getCoopList();
  }

  /**
   * 生協コンボボックス用リスト取得
   */
  private getCoopList(): Array<any> {
    const list: Array<any> = [];
    let obj: any;

    obj = new Object;
    obj.code = '0';
    obj.value = '';
    obj.displayValue = '';
    list.push(obj);

    obj = new Object;
    obj.code = '1';
    obj.value = '○';
    obj.displayValue = '1:○';
    list.push(obj);

    obj = new Object;
    obj.code = '2';
    obj.value = '×';
    obj.displayValue = '2:×';
    list.push(obj);

    return list;
  }

  /**
   * グルーピング一覧取得用VO作成
   */
  public getGroupingDataVo(): GroupingDataModel {
    const vo: GroupingDataModel = new GroupingDataModel;

    vo.EnableCoop142 = this.coop142;
    vo.EnableCoop163 = this.coop163;
    vo.EnableCoop185 = this.coop185;
    vo.EnableCoop240 = this.coop240;
    vo.EnableCoop210 = this.coop210;
    vo.EnableCoop302 = this.coop302;
    vo.EnableCoop515 = this.coop515;
    vo.EnableCoop451 = this.coop451;

    return vo;
  }

  /**
   * グルーピング一覧更新
   */
  public updateGroupingList(serverData: any): void {
    this.groupingInfoList = serverData;
  }

  /**
   * グルーピング選択OutputVo作成
   */
  public getKYMW0F00OutputVo(): KYMW0F00OutputModel {
    const vo: KYMW0F00OutputModel = new KYMW0F00OutputModel;
    vo.groupingCode = this.kymw0F00Component.dtg_GroupingInfoList.selectedItems[0].GroupingCode;

    return vo;
  }
}
